module.exports = {
    i: {
        locale: 'he',
        select: {
            placeholder: 'בבקשה תבחר',
            noMatch: 'אין נתונים תואמים',
            loading: 'טוען'
        },
        table: {
            noDataText: 'אין מידע',
            noFilteredDataText: 'עדיין אין תוצאות סינון',
            confirmFilter: 'לְסַנֵן',
            resetFilter: 'אִתחוּל',
            clearFilter: 'את כל',
            sumText: 'סה"כ'
        },
        datepicker: {
            selectDate: 'בחר תאריך',
            selectTime: 'תקופת בחירה',
            startTime: 'זמן התחלה',
            endTime: 'זמן סיום',
            clear: 'ריק',
            ok: 'בטוח',
            datePanelLabel: '[yyyy year] [m month]',
            month: 'ירח',
            month1: 'יָנוּאָר',
            month2: 'פברואר',
            month3: 'מרץ',
            month4: 'אַפּרִיל',
            month5: 'מאי',
            month6: 'יוני',
            month7: 'יולי',
            month8: 'אוגוסט',
            month9: 'סֶפּטֶמבֶּר',
            month10: 'אוֹקְטוֹבֶּר',
            month11: 'נוֹבֶמבֶּר',
            month12: 'דֵצֶמבֶּר',
            year: 'שָׁנָה',
            weekStartDay: '0',
            weeks: {
                sun: 'יְוֹם',
                mon: 'אחד',
                tue: 'שתיים',
                wed: 'שְׁלוֹשָׁה',
                thu: 'ארבע',
                fri: 'חָמֵשׁ',
                sat: 'שֵׁשׁ'
            },
            months: {
                m1: 'יָנוּאָר',
                m2: 'פברואר',
                m3: 'מרץ',
                m4: 'אַפּרִיל',
                m5: 'מאי',
                m6: 'יוני',
                m7: 'יולי',
                m8: 'אוגוסט',
                m9: 'סֶפּטֶמבֶּר',
                m10: 'אוֹקְטוֹבֶּר',
                m11: 'נוֹבֶמבֶּר',
                m12: 'דֵצֶמבֶּר'
            }
        },
        transfer: {
            titles: {
                source: 'רשימת מקור',
                target: 'רשימת מטרות'
            },
            filterPlaceholder: 'הזן תוכן חיפוש',
            notFoundText: 'הרשימה ריקה'
        },
        modal: {
            okText: 'בטוח',
            cancelText: 'לְבַטֵל'
        },
        poptip: {
            okText: 'בטוח',
            cancelText: 'לְבַטֵל'
        },
        page: {
            prev: 'עמוד קודם',
            next: 'עמוד הבא',
            total: 'מְשׁוּתָף',
            item: 'לְהִתְפַּשֵׁט',
            items: 'לְהִתְפַּשֵׁט',
            prev5: '5 דפים קדימה',
            next5: '5 עמודים אחורה',
            page: 'מאמר / עמוד',
            goto: 'קפוץ אל',
            p: 'עמוד'
        },
        rate: {
            star: 'כוכב',
            stars: 'כוכב'
        },
        time: {
            before: 'קָדִימָה',
            after: 'חזור',
            just: 'רַק',
            seconds: 'שְׁנִיָה',
            minutes: 'דַקָה',
            hours: 'שָׁעָה',
            days: 'שָׁמַיִם'
        },
        tree: {
            emptyText: 'אין מידע'
        }
    }
};